module.exports = __webpack_public_path__ + "static/media/696f077e-8c8d-48ec-9ef9-14356ff1743b.__CR0,0,600,180_PT0_SX600_V1___.7718bd2d.jpeg";